function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import Backbone from '@polleverywhere/backbone';
import Base from './base.js';
import Instance from './mixins/_instance'; // Model that represents Join Instructions. Components that are passed
// this as the model should render the activity as Join Instructions.

var JoinInstructions = /*#__PURE__*/function (_Base) {
  _inheritsLoose(JoinInstructions, _Base);

  function JoinInstructions() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = JoinInstructions.prototype;

  _proto.initialize = function initialize(options) {
    if (options === void 0) {
      options = {};
    }

    _Base.prototype.initialize.apply(this, arguments);

    this.set({
      type: 'join_instructions',
      // required for activity factory
      presenter_key: 'joinInstructions',
      // type required for Instance
      shared_key: 'joinInstructions' // type required for Instance

    }); // id required for toolkit/components/visualization

    this.id = 'joinInstructions'; // Instance required for lib/apps/activities

    this.include(Instance); // flashOptions required for activity-visualization + viz-chart

    this._flashOptions = new Backbone.Model({
      showInstructions: false
    });
  } // showUrl() required for toolkit/components/visualization
  ;

  _proto.showUrl = function showUrl() {
    return '/join_instructions';
  } // start() required for singularity/lib/apps/activities
  ;

  _proto.start = function start() {} // type() required for Instance
  ;

  _proto.type = function type() {
    return this.get('type');
  } // flashOptions() required for activity-visualization + viz-chart
  ;

  _proto.flashOptions = function flashOptions() {
    return this._flashOptions;
  };

  return JoinInstructions;
}(Base);

export { JoinInstructions as default };